function getGTMId(auth) {
    let gtmId = 'GTM-PD5V9F9B';
    if (auth.user().roleId == 4) {
        gtmId = 'GTM-NK99NQR7';
    }
    return gtmId;
}

export { getGTMId };
